import styled from "styled-components";

export const IFrame = styled.iframe`
  width: 100%;
  height: calc(100vh - 70px);
  border: 0;
`;
